<template>
  <v-container class="noticia">
    <v-row>
      <v-col cols="12" lg="8" md="8" sm="12">
        <el-button @click="$router.push('/noticias')" type="text" icon="el-icon-arrow-left">
          Regresar
        </el-button>
        <v-breadcrumbs
          class="pt-0 pr-0 pl-4 breadcrumbs"
          :items="route"
          divider="/"
        ></v-breadcrumbs>
        <v-img
          v-on:error="onImgError"
          gradient="to top right, rgba(100,115,201,.1), rgba(25,32,72,.3)"
          :src="validateImage(newsPath + noticia.image, failed_image)"
          height="400px"
          
          cover
        ></v-img>
        <div class="title-wrapper">
          <div class="date-wrapper">
            <div class="day">{{ new Date(noticia.date).getDay() }}</div>
            <div class="month uppercase">{{ getMonth(noticia.date) }}</div>
            <div class="year">{{ new Date(noticia.date).getFullYear() }}</div>
          </div>
          <h4 class="white--text new-title">{{ fixTitleLength(noticia.title) }}</h4>
        </div>
        <p class="body-2 mt-10" v-html="noticia.content"></p>
      </v-col>
      <v-col cols="12" lg="4" md="4" sm="12" class="right-aside py-6">
        <v-card class="noticias-recients-wrapper elevation-0">
          <v-card-title class="text-center">
            <h6>Noticias recientes</h6>
          </v-card-title>
          <v-card-text>
            <div class="recient-news">
              <RecentNews v-for="noticia in lastThreeItems" :key="noticia.id" :noticia="noticia" />
            </div>
          </v-card-text>
        </v-card>
        <v-card @click="openPodcast()" class="mt-6 pa-0 podcast">
          <v-img height="220" position="center center" :src="podcast" class="podcast-image"> </v-img>
          <v-card-text>
            <h6 class=" mt-1">Radar Oceanografico</h6>
            <p>Escucha el podcast de la UABC Radio</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import $ from "jquery";
const MAX_LENGTH = 55;

export default {
  name: "noticia",
  data: () => ({
    failed_image: false,
    noticia: null,
    route: [
      {
        text: "Noticias",
        disabled: false,
        to: "/noticias"
      }
    ]
  }),
  components: {
    RecentNews: () => import(/* webpackPrefetch: true */ "../components/Lists/recentNews.vue")
  },
  computed: {
    podcast: () => require("../assets/images/uabc_radio_radar_1.jpeg"),
    newsPath: () => $(location).attr("origin") + "/archivos/noticias/",
    openPodcast() {
      window.open("http://radio.uabc.mx/radar-oceanografico");
    },
    loadData() {
      //   console.warn(this.$route.params.id);
      this.noticia = this.$info.home.noticias[this.$route.params.id];
      console.warn(this.noticia);
      if (!this.noticia) {
        // alert(mamó);
        // this.$router.push({ name: "404" });
      }
    },
    lastThreeItems() {
      const last_index = this.$info.home.noticias.length - 1;
      const three_items = this.$info.home.noticias.slice(last_index - 3, last_index);
      three_items.forEach(noticia => (noticia.id = this.$info.home.noticias.indexOf(noticia)));
      return three_items;
    }
  },
  methods: {
    getMonth(date) {
      const months = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre"
      ];
      // get fist 3 letters of month
      const month = new Date(date).getMonth();
      const last_3_letters = months[month].slice(0, 3);
      return last_3_letters;
    },
    validateImage(image, failed_image) {
      return !failed_image ? image : "https://www.uabc.mx/wp-content/uploads/2022/01/RFoto01.jpg";
    },  
    onImgError: function(event) {
      this.failed_image = true;
    },
    fixTitleLength(text, max_length = MAX_LENGTH){
      return text.length > max_length ? text.slice(0, max_length) + "..." : text;
    }
  },
  created: function() {
    this.loadData;
    this.route.push({
      text: this.fixTitleLength(this.noticia.title, 35),
      disabled: true,
      to: `/noticias`
    });
  },
  watch: {
    "$route.params.id": {
      handler: function(oldValue, newValue) {
        this.loadData;
        this.failed_image = false;
        if (oldValue != newValue && this.route.length > 1) {
          this.route.pop();
          this.route.push({
            text: this.fixTitleLength(this.noticia.title, 35),
            disabled: true
          });
        }
      },
      deep: true,
      immediate: true
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/global";
.title-wrapper {
  display: flex;
  position: relative;
  flex-direction: row;
  align-items: stretch;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  margin-top: -60px;
  z-index: 100;
  background-color: $green;
  min-height: 90px;
  .date-wrapper {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    width: 85px;
    min-width: 85px;
    background-color: black;
    margin-right: 2%;
    .day {
      line-height: 1.1;
      font-size: 25px;
      font-weight: 600;
    }
    .month {
      line-height: 1.3;
      font-size: 15px;
      font-weight: 600;
    }
    .year {
      line-height: 1.3;
      font-size: 15px;
      font-weight: 600;
    }
    * {
      color: white !important;
    }
  }

  .new-title {
    display: flex ;
    flex: 1 !important;
    padding: 5px 10px;
    align-items: center;
  }
}
.right-aside {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 60px;
}
.header-6 {
  border-left: $green solid 4px;
  padding-left: 5px;
  font-size: 20px;
}
.podcast {
  max-width: 330px !important;
  border-radius: 10px;
}
.noticias-recients-wrapper {
  max-width: 330px !important;
  border-radius: 10px;
}
h4 {
  font-size: large !important;
  line-height: normal;
  text-align: left !important;
}
h5 {
  margin: 30px 0 15px 0;
}

h6 {
  border-left: $green solid 4px;
  padding-left: 5px;
  font-size: 20px;
  text-overflow: ellipsis;
  overflow: hidden;
  // Addition lines for 2 line or multiline ellipsis
  display: -webkit-box !important;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
}
.recient-news {
  display: flex;
  flex-direction: column;
}

.noticia {
  padding-top: 100px;
}

@media (max-width: $screen-lg-min) and (min-width: 500px) {
  .new-title {
    // color: red;
  }
}

@media only screen and (max-width: $screen-lg-min) {
  .noticia {
    padding-top: 75px;
  }
  .noticias-recients-wrapper {
    width: 100% !important;
    max-width: 100% !important;
  }

  .right-aside {
    margin-top: 0px;
  }
  .title-wrapper {
    width: 90%;
  }

  h4 {
    font-size: large !important;
    line-height: normal;
    overflow: hidden;
    // Addition lines for 2 line or multiline ellipsis
    // display: -webkit-box !important;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    white-space: normal;
  }
  .new-title {
    // color: blue;
    text-overflow: ellipsis;
  }
}

@media (max-width: 500px) {
  .title-wrapper {
    width: 95%;
  }
  h4 {
    overflow: hidden;
    font-size: medium !important;
    line-height: normal;
    -webkit-line-clamp: 2;
  }
  .new-title {
    // color: green;
  }
}
</style>
